import React from 'react';

import VersionEndOfSupport from '@totem/components/software/software_package/version/versionEndOfSupport';
const VersionDetails = () => {
  return <VersionEndOfSupport />;
};

export default VersionDetails;
